import React, { forwardRef, useRef } from "react";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactSection = forwardRef((props, ref) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm("service_82xd8w8", "template_asuoyxx", form.current, "x8FsCFN9PWQrC3UuY")
    .then(
      (result) => {
        console.log(result.text);
        toast.success("✅ Message sent successfully!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        form.current.reset();
      },
      (error) => {
        console.log(error.text);
        toast.error("❌ Failed to send message, please try again.", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    );

  };
  return (
    <section
      ref={ref}
      className="overflow-hidden bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100"
    >
      <div className="container px-4 mx-auto pt-16 pb-20">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-orange-700">
          Contact Us
        </h2>

        <div className="flex flex-wrap -mx-4">
          {/* Contact Info */}
          <div className="w-full lg:w-1/2 p-4">
            <div className="flex flex-col justify-between h-full max-w-xl mx-auto">
              <div>
                <div className="px-2 py-1 rounded-md border border-orange-100 bg-orange-50 inline-flex items-center gap-2 mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M8.5 1.215H3.5C2 1.215 1 2.215 1 3.715V6.715C1 8.215 2 9.215 3.5 9.215H5.5L7.725 10.695C8.055 10.915 8.5 10.68 8.5 10.28V9.215C10 9.215 11 8.215 11 6.715V3.715C11 2.215 10 1.215 8.5 1.215ZM7.75 5.625H4.25C4.045 5.625 3.875 5.455 3.875 5.25C3.875 5.045 4.045 4.875 4.25 4.875H7.75C7.955 4.875 8.125 5.045 8.125 5.25C8.125 5.455 7.955 5.625 7.75 5.625Z"
                      fill="#FF7100"
                    ></path>
                  </svg>
                  <span className="text-orange-500 text-sm font-medium">
                    Contact Support
                  </span>
                </div>

                <h1 className="text-3xl lg:text-5xl font-bold font-heading mb-4">
                  How can we help you today?
                </h1>

                {/* Card */}
                <div className="lg:w-96 w-auto h-auto bg-white shadow-xl lg:p-6 p-4 rounded-2xl">
                  {/* Logo */}
                  <div className="flex justify-center mb-6">
                    <img
                      src="/logo.jpg"
                      alt="Company Logo"
                      className="w-36 h-36 object-contain rounded-full shadow-md"
                    />
                  </div>

                  {/* Contact Info */}
                  <div className="space-y-5 text-black">
                    <div className="flex items-center">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.3092 18.3098C22.0157 18.198 21.8689 18.1421 21.7145 18.1287C21.56 18.1154 21.4058 18.1453 21.0975 18.205L17.8126 18.8416C17.4392 18.9139 17.2525 18.9501 17.0616 18.9206C16.8707 18.891 16.7141 18.8058 16.4008 18.6353C13.8644 17.2551 12.1853 15.6617 11.1192 13.3695C10.9964 13.1055 10.935 12.9735 10.9133 12.8017C10.8917 12.6298 10.9218 12.4684 10.982 12.1456L11.6196 8.72559C11.6759 8.42342 11.7041 8.27233 11.6908 8.12115C11.6775 7.96998 11.6234 7.82612 11.5153 7.5384L10.6314 5.18758C10.37 4.49217 10.2392 4.14447 9.95437 3.94723C9.6695 3.75 9.29804 3.75 8.5551 3.75H5.85778C4.58478 3.75 3.58264 4.8018 3.77336 6.06012C4.24735 9.20085 5.64674 14.8966 9.73544 18.9853C14.0295 23.2794 20.2151 25.1426 23.6187 25.884C24.9335 26.1696 26.0993 25.1448 26.0993 23.7985V21.2824C26.0993 20.5428 26.0993 20.173 25.9034 19.8888C25.7076 19.6046 25.362 19.4729 24.6708 19.2096L22.3092 18.3098Z"
                          stroke="#000"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      <h5 className="ml-4 text-base">+91 9345511498,<br /> +91 7339491375,<br /> +91 9080350032</h5>
                    </div>

                    <div className="flex items-center">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.81501 8.75L10.1985 13.6191C12.8358 15.2015 14.1544 15.9927 15.6032 15.9582C17.0519 15.9237 18.3315 15.0707 20.8905 13.3647L27.185 8.75"
                          stroke="#000"
                          strokeWidth="2"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                      <h5 className="ml-4 text-base">
                        mindspark.revolutions@gmail.com
                      </h5>
                    </div>

                    <div className="flex items-center">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M25 12.9169C25 17.716 21.1939 21.5832 18.2779 24.9828C16.8385 26.6609 16.1188 27.5 15 27.5C13.8812 27.5 13.1615 26.6609 11.7221 24.9828C8.80612 21.5832 5 17.716 5 12.9169C5 10.1542 6.05357 7.5046 7.92893 5.55105C9.8043 3.59749 12.3478 2.5 15 2.5C17.6522 2.5 20.1957 3.59749 22.0711 5.55105C23.9464 7.5046 25 10.1542 25 12.9169Z"
                          stroke="#000"
                          strokeWidth="2"
                        ></path>
                      </svg>
                      <h5 className="ml-4 text-base">
                        SMRV Road, Vadasery, Nagercoil
                      </h5>
                    </div>
                  </div>

                  {/* Social Links */}
                  <div className="flex items-center justify-center border-t border-gray-100 pt-6 mt-6">
                    <a
                      href="https://www.linkedin.com/company/mindspark-innovations"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-12 h-12 mx-2 bg-blue-700 rounded-full"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-white"
                      >
                        <path
                          d="M22.23 0H1.77C0.79 0 0 0.79 0 1.77v20.46C0 23.21 0.79 24 1.77 24h20.46C23.21 24 24 23.21 24 22.23V1.77C24 0.79 23.21 0 22.23 0zM7.06 20.43H3.46V9.08h3.6v11.35zM5.26 7.56c-1.2 0-2.18-.98-2.18-2.18S4.06 3.2 5.26 3.2c1.2 0 2.18.98 2.18 2.18 0 1.2-.98 2.18-2.18 2.18zM20.54 20.43h-3.6v-5.7c0-1.36-.03-3.12-1.9-3.12-1.9 0-2.19 1.48-2.19 3.02v5.8h-3.6V9.08h3.46v1.55h.05c.48-.91 1.66-1.87 3.42-1.87 3.67 0 4.36 2.42 4.36 5.58v6.19z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-1/2 p-4">
            <form ref={form} onSubmit={sendEmail}>
              <div className="border border-gray-100 rounded-3xl p-6 max-w-xl mx-auto bg-white shadow-lg">
                <div className="flex flex-wrap -mx-4">
                  <div className="w-full lg:w-1/2 p-4">
                    <label className="text-sm font-medium mb-2 block">
                      First name
                    </label>
                    <input
                      className="w-full rounded-full p-4 outline-none border border-gray-100 shadow placeholder-gray-500 focus:ring focus:ring-orange-200 transition duration-200"
                      type="text"
                      placeholder="First name"
                      name="first_name"
                    />
                  </div>
                  <div className="w-full lg:w-1/2 p-4">
                    <label className="text-sm font-medium mb-2 block">
                      Last name
                    </label>
                    <input
                      className="w-full rounded-full p-4 outline-none border border-gray-100 shadow placeholder-gray-500 focus:ring focus:ring-orange-200 transition duration-200"
                      type="text"
                      placeholder="Last name"
                      name="last_name"
                    />
                  </div>
                </div>

                <div className="flex flex-wrap -mx-4">
                  <div className="w-full lg:w-1/2 p-4">
                    <label className="text-sm font-medium mb-2 block">
                      Email
                    </label>
                    <input
                      className="w-full rounded-full p-4 outline-none border border-gray-100 shadow placeholder-gray-500 focus:ring focus:ring-orange-200 transition duration-200"
                      type="email"
                      placeholder="Email address"
                      name="email"
                    />
                  </div>
                  <div className="w-full lg:w-1/2 p-4">
                    <label className="text-sm font-medium mb-2 block">
                      Phone
                    </label>
                    <input
                      className="w-full rounded-full p-4 outline-none border border-gray-100 shadow placeholder-gray-500 focus:ring focus:ring-orange-200 transition duration-200"
                      type="tel"
                      placeholder="Phone number"
                      name="phone"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label className="text-sm font-medium mb-2 block">
                    What can we help you with?
                  </label>
                  <textarea
                    className="w-full rounded-3xl p-4 outline-none border border-gray-100 shadow placeholder-gray-500 focus:ring focus:ring-orange-200 transition duration-200"
                    rows="4"
                    placeholder="Please include a short description of your request"
                    name="message"
                  ></textarea>
                </div>

                <button
                  className="w-full py-4 px-6 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold shadow outline-none focus:ring focus:ring-orange-200 transition duration-200"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
          
        </div>
        {/* Google Map */}
          <div className="mt-10 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
            <iframe
              title="Google Map - Vadasery, Nagercoil"
              src="https://www.google.com/maps?q=8.196676,77.431189&hl=en&z=17&output=embed"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />

          </div>
      </div>
       <ToastContainer />
    </section>
  );
});

export default ContactSection;
